import React, { Component, Fragment } from "react";
import { withRouter } from "react-router";
import { inject, observer } from "mobx-react";
// import { toJS } from "mobx";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
  Utils,
} from "arv-reactcomponents";
import PropTypes from "prop-types";
// import { loadReCaptcha } from "react-recaptcha-google";
import {
  pageType,
  PAYMENTPAGE,
  PRICINGOVERVIEW,
  Checkout,
} from "npmlinks-constants";
import PricingOverview from "../../../component/PricingOverview";
import PaymentSavedCard from "../../../component/PaymentSavedCard";
import DynamicImportComponent from "../../../component/DynamicImportComponent";
import PaymentOptions from "../../../component/PaymentOptions";
import PlaceOrderButton from "../../../component/PlaceOrderButton";
import TotalPayable from "../../../component/PaymentComponent/TotalPayable";
import {
  setPageType,
  removedUndefinedFromObj,
  isPaymentOptionsNotAvailable,
  queryParamsToObject,
  ToCurrency,
} from "../../../utils";
import CheckoutValidator from "../../../component/CheckoutValidator";
import ProductFilters from "../../../component/ProductFilters";
import Analytics from "../../../analytics";
import Loyalty from "../../../component/Loyalty";

const { TEXT, TOTAL } = PRICINGOVERVIEW;

@withRouter
@inject(
  "CheckoutStore",
  "PaymentStore",
  "AddressStore",
  "SavedCardStore",
  "NetbankingStore",
  "WalletStore",
  "LoginStore",
  "LoyaltyStore",
  "RazorpayStore",
  "CreditCardStore",
  "CommonStore",
)
@observer
class PaymentView extends Component {
  static ShowToastr(message = PAYMENTPAGE.ERRORS.SOMETHING_ERROR_MSG) {
    Toastr.showToastr({
      className: "nwc-toastr-list-danger nw-toastr",
      message,
      timeout: 5000,
    });
  }
  constructor() {
    super();
    this.state = {
      isPaymentOptions: true,
      loyalty: false,
    };
    this.init = this.init.bind(this);
    this.loyaltyCheck = this.loyaltyCheck.bind(this);
  }

  /**
   * when payment page renders check  from where we are coming
   * 1) reload/payment failure --
   * reload -- go to shipping  ,  (A) we don't have  getPaymentTypesV4Request object
   *                              show/unshow toaster message for payment types and go to
   * transaction failure :  stay on payment page
   * 3) payment failure -- different payment failure handling different way --
   *                    go to shipping page(IMS out of stock, pricing change),
   *                    otherwise on payment failure stay on same page make api call (A)
   *
   * 2) coming from checkout--  (A)
   *
   * A) based on cart Items
   * if cart item is there check validity,  fetch payment methode , show loader
   * else get cart items check validity,  fetch payment methode , show loader
   */
  componentDidMount() {
    setPageType(pageType.checkout);
    Analytics.pageView(window.pageType);
  }
  componentWillUnmount() {
    this.props.PaymentStore.initPaymentOptions(
      Object.keys(this.props.PaymentStore.paymentOptionsSelection),
    );
  }

  get isPaymentFailurePage() {
    return (
      this.props.location.pathname ===
      Checkout.CHECKOUT_ROUTES.SUPPORTED.paymentfailure
    );
  }

  get isLoyalty() {
    return (
      process.env.REACT_APP_ISLOYALTY &&
      process.env.REACT_APP_ISLOYALTY === "true" &&
      Object.keys(this.props.PaymentStore.loyalty).length > 0
    );
  }

  /**
   * TODO:: when we need to update mobile mobile number otherthan primary mobile
   * then it needs to be implemented in version V2
   *   //createCookie("walletMobileNumber",this.props.LoginStore.getMobileNumber);
   */
  async init() {
    try {
      let localStorageData, paymentTypesRequestData;
      // when url is payment failure page, checkout data should be initialied  from local storage and till this point data should be available
      const {
        paymentTypes,
      } = this.props.CheckoutStore.getPaymentOptionsRequestData;
      if (this.isPaymentFailurePage) {
        localStorageData = Utils.localStorage.getItem("paymentRequest");
        paymentTypesRequestData = Utils.localStorage.getItem("paymentTypes");
      }

      if (
        (this.isPaymentFailurePage && localStorageData) ||
        (paymentTypes && paymentTypes.length)
      ) {
        const paymentOptions = await this.props.PaymentStore.getPaymentOptions(
          this.isPaymentFailurePage
            ? paymentTypesRequestData
            : this.props.CheckoutStore.getPaymentOptionsRequestData,
          this.props.LoginStore.mobileNumber,
        );
        const { savedCards, wallet, e_wallet = {}, loyalty = {}, upi = {}, CREDIT_CARD = [], DEBIT_CARD = [], eligiblePGs = {} } = paymentOptions;
        if (isPaymentOptionsNotAvailable(paymentOptions)) {
          this.setState({ isPaymentOptions: false });
          return;
        }
        if (savedCards && savedCards.length) {
          this.props.SavedCardStore.initSavedCard(paymentOptions);
        }
        this.props.NetbankingStore.setNetbankingOptions(paymentOptions);
        this.props.WalletStore.initWalletOptions(wallet);
        this.props.WalletStore.initEWalletOptions(e_wallet);
        this.props.LoyaltyStore.setLoyaltyVerified(loyalty.verified);
        this.props.RazorpayStore.setUPIData(upi);
        this.props.CreditCardStore.setCardData(CREDIT_CARD, DEBIT_CARD, eligiblePGs);
      } else {
        PaymentView.ShowToastr(PAYMENTPAGE.ERRORS.NO_PAYMENT_OPTIONS);
        this.props.history.replace(Checkout.CHECKOUT_ROUTES.DEFAULT, {});
        return;
      }
    } catch (err) {
      PaymentView.ShowToastr(PAYMENTPAGE.ERRORS.SOMETHING_ERROR_MSG);
      this.props.history.replace(Checkout.CHECKOUT_ROUTES.DEFAULT, {});
    }
  }

  get pricingDetails() {
    const {
      CheckoutStore: { pricingOverviewData },
    } = this.props;
    let pricingDetails = {};
    if (this.isPaymentFailurePage) {
      pricingDetails = this.isPaymentFailurePage
        ? Utils.localStorage.getItem("paymentRequest") &&
          Utils.localStorage.getItem("paymentRequest").pricingDetails
        : {};
      pricingDetails = Object.assign({}, pricingDetails, {
        total: pricingDetails && pricingDetails.netAmount,
        subtotal: pricingDetails && pricingDetails.mrp,
        discounts: pricingDetails && pricingDetails.totalDiscount,
      });
    } else {
      pricingDetails = pricingOverviewData;
    }
    return pricingDetails;
  }

  get pricingOverview() {
    const {
      LoyaltyStore: { isLoyaltyVerified },
      PaymentStore: { loyalty },
    } = this.props;
    let loyaltyValue;
    const {
      subtotal,
      discounts,
      tax,
      shippingCost,
      total,
    } = this.pricingDetails;
    let newTotal = total;
    if (this.state.loyalty && isLoyaltyVerified) {
      loyaltyValue = loyalty && loyalty.points && loyalty.points.loyaltyValue;
      newTotal = loyaltyValue >= total ? 0 : total - loyaltyValue;
    }

    return removedUndefinedFromObj({
      [TEXT.subtotal]: subtotal,
      [TEXT.discounts]: discounts,
      [TEXT.tax]: tax,
      [TEXT.shippingCost]: shippingCost,
      [TEXT.loyalty]: loyaltyValue,
      [TOTAL.total]: newTotal,
    });
  }
  get PaymentTypeMessage() {
    let walletTitle;
    const {
      savedCards = [],
      paymentOptions = [],
    } = this.props.PaymentStore.paymentOptionsResponse;
    const isSavedCard = savedCards && savedCards.length;
    const isPaymentTypeOptions = paymentOptions && paymentOptions.length;
    if (isPaymentTypeOptions && isSavedCard) {
      walletTitle = PAYMENTPAGE.PAYMENTOPTIONS_TITLE_WITHSAVEDCARD;
    } else if (isPaymentTypeOptions) {
      walletTitle = PAYMENTPAGE.PAYMENTOPTIONS_TITLE_WITHOUTSAVEDCARD;
    } else {
      walletTitle = "";
    }
    return walletTitle;
  }

  loyaltyCheck(flag) {
    this.props.PaymentStore.setPaymentOptionLoyalty(flag);
    this.setState({
      loyalty: flag,
    });
  }
  get showPaymentOptions() {
    const {
      paymentOptions = [],
    } = this.props.PaymentStore.paymentOptionsResponse;
    if (this.pricingOverview.Total === 0) {
      this.props.PaymentStore.resetPaymentOptions(paymentOptions);
      return true;
    }
    return false;
  }

  render() {
    const { isDesktop } = this.props.CommonStore;
    const { isPaymentOptions } = this.state;
    return (
      <div>
        {/* <DynamicImportComponent preload path="Preload" /> */}
        <CheckoutValidator.component
          preValidate
          proceedToPayment={false}
          onSuccess={this.init}
          redirect
          paymentfailure={this.isPaymentFailurePage}
        />
        {(!this.props.parentLoading && isPaymentOptions && (
          <GridContainer className="nw-paymentview-page">
            <GridRow>
              <GridColumn className="nwc-grid-col-sm-8">
                <TotalPayable.component {...this.pricingDetails} />
                {this.isLoyalty ? (
                  <Loyalty.component
                    loyalty={this.props.PaymentStore.loyalty}
                    loyaltyCheck={this.loyaltyCheck}
                  />
                ) : null}
                <div className="nw-paymentview-paymentmethodstitle">
                  <i className="icomoon-payment_method nw-paymentview-icon" />
                  <span>
                    <span className="nw-paymentview-methodstitlemain">
                      {PAYMENTPAGE.PAYMENTMETHODS_SUBTITLE}
                    </span>
                    {this.isLoyalty ? (
                      <span className="nw-paymentview-payableamount">
                        ({ToCurrency(this.pricingOverview.Total || 0)} Payable)
                      </span>
                    ) : null}
                  </span>
                </div>
                <PaymentSavedCard.component
                  isLoyalty={this.isLoyalty}
                  className="nw-paymentview-savedcards"
                  OptionStatus={this.showPaymentOptions}
                />
                <div className="nw-paymentview-options">
                  <PaymentOptions.component
                    className="nw-paymentview-options-wrapper"
                    OptionStatus={this.showPaymentOptions}
                  />
                </div>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-4 nw-paymentview-leftcol">
                {(isDesktop && (
                  <PricingOverview.component
                    pricingOverviewData={this.pricingOverview}
                  />
                )) ||
                  null}
                <PlaceOrderButton.component />
              </GridColumn>
            </GridRow>
          </GridContainer>
        )) || (
          <GridContainer>
            <GridRow>
              <GridColumn className="nw-paymentview-nooptions">
                <div className="nw-paymentview-title">
                  Sorry, No payment options available.
                </div>
                <div className="nw-paymentview-message">
                  {" "}
                  May be try with a lesser amount or a different location.
                </div>
              </GridColumn>
            </GridRow>
          </GridContainer>
        )}
      </div>
    );
  }
}

PaymentView.wrappedComponent.propTypes = {
  parentLoading: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({
      subtotal: PropTypes.number.isRequired,
      discounts: PropTypes.number.isRequired,
      tax: PropTypes.number.isRequired,
      shippingCost: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    updateCart: PropTypes.func.isRequired,
    shippingValidData: PropTypes.shape({
      isAllStoredPickup: PropTypes.bool.isRequired,
      isValid: PropTypes.bool.isRequired,
    }).isRequired,
    getPaymentOptionsRequestData: PropTypes.shape({}),
  }).isRequired,
  PaymentStore: PropTypes.shape({
    paymentOptionsSelection: PropTypes.shape({}).isRequired,
    PaymentTypeOptions: PropTypes.shape({}).isRequired,
    initPaymentOptions: PropTypes.func.isRequired,
    resetPaymentOptions: PropTypes.func,
    paymentOptionsResponse: PropTypes.shape({
      savedCards: PropTypes.shape({}).isRequired,
      paymentOptions: PropTypes.shape({}).isRequired,
    }).isRequired,
    selectedPaymentOptions: PropTypes.string.isRequired,
    setPaymentLoading: PropTypes.string.isRequired,
    getPaymentOptions: PropTypes.func.isRequired,
    loyalty: PropTypes.shape(PropTypes.object),
    setPaymentOptionLoyalty: PropTypes.func.isRequired,
  }).isRequired,
  SavedCardStore: PropTypes.shape({
    initSavedCard: PropTypes.func.isRequired,
    setUserSavedCardData: PropTypes.func.isRequired,
    savedCards: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  NetbankingStore: PropTypes.shape({
    setNetbankingOptions: PropTypes.func.isRequired,
    savedCards: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  WalletStore: PropTypes.shape({
    initWalletOptions: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    getMobileNumber: PropTypes.func.isRequired,
  }).isRequired,
  LoyaltyStore: PropTypes.shape({
    isLoyaltyVerified: PropTypes.bool,
  }).isRequired,
  RazorpayStore: PropTypes.shape({
    setUPIData: PropTypes.func.isRequired,
  }).isRequired,
  CreditCardStore: PropTypes.shape({
    setCardData: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject(
    "CheckoutStore",
    "PaymentStore",
    "AddressStore",
    "SavedCardStore",
    "NetbankingStore",
    "WalletStore",
    "LoginStore",
    "CommonStore",
  )(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PaymentView.wrappedComponent,
  component: PaymentView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/Checkout/PaymentView/index.js